export const dashboardConfig = {
  wf_name: "Kotak - DIFC",
  created_by: "",
  created_at: "",
  is_active: true,
  is_deleted: false,
  last_updated_at: "",
  last_updated_by: "",
  configuration_history: [
    {
      changes: {},
      module: "",
      updated_by: "",
      updated_at: "",
    },
  ],
  wf_journey: [
    {
      step: 1,
      module_name: "User list",
      form_structure: {
        name: "client_details",
        layout: "regular",
        sections: [
          {
            title: "Activity",
            name: "activity",
            order: "1",
            show: "true",
            form_groups: [
              {
                type: "activity",
                name: "comment",
                title: "Comment",
                id: "comment",
              },
            ],
          },
          {
            title: "Detail View",
            name: "detail_view",
            order: "1",
            show: "true",
            form_groups: [
              {
                type: "label",
                label: "Applicant Details",
              },
              {
                type: "nav_panel",
                input_fields: [
                  {
                    title: "Account Number",
                  },
                  {
                    title: "Account Details",
                  },
                  {
                    title: "CRN Details",
                  },
                  {
                    title: "User Details",
                  },
                  {
                    title: "Personal Information",
                  },
                  {
                    title: "Information Verification",
                  },
                  {
                    title: "Family Members",
                  },
                  {
                    title: "Bank Account Details",
                  },
                  {
                    title: "Address Details",
                  },
                  {
                    title: "Nationality Information",
                  },
                  {
                    title: "Basic Occupational Details",
                  },
                  {
                    title: "Financial Details",
                  },
                  {
                    title: "Net Worth",
                  },
                  {
                    title: "Appropriate Annual Income",
                  },
                  {
                    title: "Beneficial Owner Details",
                  },
                  {
                    title: "Risk Profiling",
                  },
                  {
                    title: "Additional Documents Reqested",
                  },
                  {
                    title: "Comments",
                  },
                ],
              },
              {
                title: "Account Number",
                name: "account_number",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "current_account_number",
                        label: "Current Account Number",
                        size: "col-12",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Account Details",
                name: "account_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Account Details",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_1",
                        input_fields: [
                          {
                            name: "client_type",
                            label: "Type of client",
                            size: "col-4",
                          },
                          {
                            name: "account_type",
                            label: "Account type",
                            size: "col-4",
                          },
                          {
                            name: "mode_of_operation",
                            label: "Mode of operation",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "Added applicants details",
                        input_fields: [
                          {
                            name: "user_name",
                            label: "User name",
                            size: "col-4",
                          },
                          {
                            name: "mobile_number",
                            label: "Mobile No",
                            size: "col-4",
                          },
                          {
                            name: "email",
                            label: "Email address",
                            size: "col-4",
                          },
                          {
                            name: "birth_date",
                            label: "Date of birth",
                            size: "col-4",
                          },
                          {
                            name: "nationality",
                            label: "Nationality",
                            size: "col-4",
                          },
                          {
                            name: "residence_country",
                            label: "Country of residence",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "user_name",
                            label: "User name",
                            size: "col-4",
                          },
                          {
                            name: "mobile_number",
                            label: "Mobile No",
                            size: "col-4",
                          },
                          {
                            name: "email",
                            label: "Email address",
                            size: "col-4",
                          },
                          {
                            name: "birth_date",
                            label: "Date of birth",
                            size: "col-4",
                          },
                          {
                            name: "nationality",
                            label: "Nationality",
                            size: "col-4",
                          },
                          {
                            name: "residence_country",
                            label: "Country of residence",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                type: "custom_tab",
                input_fields: [
                  {
                    label: "Kevin Heart",
                    id: 1,
                  },
                  {
                    label: "James Kart",
                    id: 2,
                  },
                ],
              },
              {
                title: "CRN Details",
                name: "crn_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "client_type",
                        label: "Type of client",
                        size: "col-12",
                      },
                    ],
                  },
                ],
              },
              {
                title: "User Details",
                name: "user_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "user_detail",
                    title: "",
                    show: "true",
                    input_fields: [
                      {
                        name: "applicant_email",
                        label: "kevinheart@gmail.com",
                        size: "col-5",
                      },
                      {
                        name: "mobile_number",
                        label: "+91-987654321",
                        size: "col-5",
                      },
                      {
                        name: "location",
                        label: "UAE",
                        size: "col-5",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Personal Information",
                name: "personal_information",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "client_classification",
                        label: "Client Classification",
                        size: "col-4",
                      },
                      {
                        name: "residence_country",
                        label: "Country of residence",
                        size: "col-4",
                      },
                      {
                        name: "nationality",
                        label: "Nationality",
                        size: "col-4",
                      },
                      {
                        name: "gender",
                        label: "Gender",
                        size: "col-4",
                      },
                      {
                        name: "citizenship",
                        label: "Citizenship",
                        size: "col-4",
                      },
                      {
                        name: "domicile",
                        label: "Domicile",
                        size: "col-4",
                      },
                      {
                        name: "mother_maiden_name",
                        label: "Mother's maiden name",
                        size: "col-4",
                      },
                      {
                        name: "marital_status",
                        label: "Marital Status",
                        size: "col-4",
                      },
                      {
                        name: "fathers_name",
                        label: "Father's Name",
                        size: "col-4",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Information Verification",
                name: "information_verification",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Information Verfication",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_1",
                        input_fields: [
                          {
                            name: "pep_or_fpep",
                            label: "Are you a PEP/FPEP?",
                            size: "col-4",
                          },
                          {
                            name: "alias",
                            label: "Alias (If any)",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            name: "national_id_type",
                            label: "National ID type",
                            size: "col-4",
                          },
                          {
                            name: "national_id_no",
                            label: "National ID No",
                            size: "col-4",
                          },
                          {
                            name: "national_id_no_country_of_issue",
                            label: "Country of Issue",
                            size: "col-4",
                          },
                          {
                            name: "issuing_authority",
                            label: "Issuing authority",
                            size: "col-4",
                          },
                          {
                            name: "nationality_details_valid_from",
                            label: "Date of Issue",
                            size: "col-4",
                          },
                          {
                            name: "nationality_details_valid_to",
                            label: "Date of Expiry",
                            size: "col-4",
                          },
                          {
                            type: "document_viewer",
                            name: "national_id_doc",
                            label: "National ID",
                            size: "col-5",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            name: "passport_number",
                            label: "Passport No.",
                            size: "col-4",
                          },
                          {
                            name: "passport_valid_from",
                            label: "Date of Issue",
                            size: "col-4",
                          },
                          {
                            name: "passport_valid_to",
                            label: "Date of Expiry",
                            size: "col-4",
                          },
                          {
                            type: "document_viewer",
                            label: "Passport",
                            size: "col-5",
                          },
                        ],
                      },
                      {
                        type: "document_viewer",
                        label: "TIN ID",
                        size: "col-6",
                      },
                      {
                        type: "document_viewer",
                        label: "Wet signature",
                        size: "col-6",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Family Members",
                name: "family_members",
                show: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Family Members",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "Added members",
                        input_fields: [
                          {
                            name: "applicant_name",
                            label: "Name of the family member",
                            size: "col-4",
                          },
                          {
                            name: "birth_date",
                            label: "Date of Birth",
                            size: "col-4",
                          },
                          {
                            name: "family_member_relationship",
                            label: "Relationship with the applicant",
                            size: "col-4",
                          },
                          {
                            name: "family_member_pep",
                            label: "PEP/FPEP or PEP/FPEP by association",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "applicant_name",
                            label: "Name of the family member",
                            size: "col-4",
                          },
                          {
                            name: "family_member_dob",
                            label: "Date of Birth",
                            size: "col-4",
                          },
                          {
                            name: "family_member_relationship",
                            label: "Relationship with the applicant",
                            size: "col-4",
                          },
                          {
                            name: "family_member_pep",
                            label: "PEP/FPEP or PEP/FPEP by association",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Bank Account Details",
                name: "bank_account_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Bank Account Details",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "Added banks",
                        input_fields: [
                          {
                            name: "applicant_name",
                            label: "Name of the family member",
                            size: "col-4",
                          },
                          {
                            name: "birth_date",
                            label: "Date of Birth",
                            size: "col-4",
                          },
                          {
                            name: "family_member_relationship",
                            label: "Relationship with the applicant",
                            size: "col-4",
                          },
                          {
                            name: "family_member_pep",
                            label: "PEP/FPEP or PEP/FPEP by association",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "applicant_name",
                            label: "Name of the family member",
                            size: "col-4",
                          },
                          {
                            name: "family_member_dob",
                            label: "Date of Birth",
                            size: "col-4",
                          },
                          {
                            name: "family_member_relationship",
                            label: "Relationship with the applicant",
                            size: "col-4",
                          },
                          {
                            name: "family_member_pep",
                            label: "PEP/FPEP or PEP/FPEP by association",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Address Details",
                name: "address_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Address Details",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "Added address",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            name: "address_line1",
                            label: "Residential Address",
                            size: "col-12",
                          },
                          {
                            name: "telephone_number",
                            label: "Telephone No",
                            size: "col-12",
                          },
                          {
                            type: "document_viewer",
                            label: "Passport",
                            size: "col-5",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            name: "tax_residence_address",
                            label: "Tax Residence Address",
                            size: "col-12",
                          },
                          {
                            name: "birth_country_not_uae",
                            label: "Country of birth is other than UAE",
                            size: "col-4",
                          },
                          {
                            name: "country_of_birth",
                            label: "Country of birth",
                            size: "col-4",
                          },
                          {
                            name: "place_country_of_birth",
                            label: "Place within country of birth",
                            size: "col-4",
                          },
                          {
                            name: "poa_or_mandate_holder",
                            label:
                              "POA or a mandate holder with a residence outside UAE?",
                            size: "col-4",
                          },
                          {
                            name: "tax_identification_name",
                            label: "Tax Identification document name",
                            size: "col-4",
                          },
                          {
                            name: "tax_identification_number",
                            label: "Tax Identification Number",
                            size: "col-4",
                          },
                          {
                            type: "document_viewer",
                            label: "FATCA",
                            size: "col-5",
                          },
                          {
                            type: "view_card",
                            custom_styles: "classname_3",
                            input_fields: [
                              {
                                name: "country_of_tax_residency",
                                label: "Country of tax residency",
                                size: "col-4",
                              },
                              {
                                name: "tax_identification_name",
                                label: "Tax Identification document name",
                                size: "col-4",
                              },
                              {
                                name: "tax_identification_number",
                                label: "Tax Identification Number",
                                size: "col-4",
                              },
                              {
                                type: "document_viewer",
                                label: "TIN card",
                                size: "col-5",
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Nationality Information",
                name: "nationality_information",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Nationality information",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "Added nationality",
                        input_fields: [
                          {
                            name: "country_name",
                            label: "Name of the country",
                            size: "col-4",
                          },
                          {
                            name: "document_name",
                            label: "Document name",
                            size: "col-4",
                          },
                          {
                            name: "document_reference_number",
                            label: "Document reference No",
                            size: "col-4",
                          },
                          {
                            name: "nationality_remarks",
                            label: "Remarks",
                            size: "col-12",
                          },
                          {
                            type: "document_viewer",
                            label: "passport",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "country_name",
                            label: "Name of the country",
                            size: "col-4",
                          },
                          {
                            name: "document_name",
                            label: "Document name",
                            size: "col-4",
                          },
                          {
                            name: "document_reference_number",
                            label: "Document reference No",
                            size: "col-4",
                          },
                          {
                            name: "nationality_remarks",
                            label: "Remarks",
                            size: "col-12",
                          },
                          {
                            type: "document_viewer",
                            label: "passport",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Basic Occupational Details",
                name: "basic_occupation_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Nationality information",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_2",
                        input_fields: [
                          {
                            name: "education_type",
                            label: "Education",
                            size: "col-4",
                          },
                          {
                            name: "occupation",
                            label: "Occupation",
                            size: "col-4",
                          },
                          {
                            name: "business_name",
                            label: "Name of business",
                            size: "col-4",
                          },
                          {
                            name: "industry",
                            label: "Industry",
                            size: "col-4",
                          },
                          {
                            name: "registered_date",
                            label: "Date of incorporation/registration",
                            size: "col-4",
                          },
                          {
                            name: "conducted_activities",
                            label: "Activities conducted out of this business.",
                            size: "col-4",
                          },
                          {
                            name: "establishment_structure",
                            label: "Structure of the establishment",
                            size: "col-4",
                          },
                          {
                            name: "ownership_pattern",
                            label: "Ownership pattern",
                            size: "col-4",
                          },
                          {
                            name: "controllers",
                            label:
                              "Are there any controllers who are neither shareholders nor beneficial owners?",
                            size: "col-4",
                          },
                          {
                            name: "controller_names",
                            label: "Controller Name",
                            size: "col-4",
                          },
                          {
                            name: "political_person_involved",
                            label:
                              "Are there any political person involved directly or indirectly in your business?",
                            size: "col-4",
                          },
                          {
                            name: "cash_sensitive_business",
                            label: "Is the business cash insentive?",
                            size: "col-4",
                          },
                          {
                            name: "nominee_shareholders_present",
                            label:
                              "Does your company/business have nominee shareholders or directors or shares in bearer form?",
                            size: "col-4",
                          },
                          {
                            name: "unknown_customer_payments",
                            label:
                              "Do you receive payments from customers who are not known to you?",
                            size: "col-4",
                          },
                          {
                            label:
                              "How do you meet prospective new customers a business?",
                            name: "initiating_prospective",
                            size: "col-4",
                          },
                          {
                            name: "applicant_business_countries",
                            label:
                              "Countries with which the applicant does business or has links",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Financial Details",
                name: "financial_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Financial details",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_1",
                        input_fields: [
                          {
                            // "name" : "professional_client_details_checkbox_2",
                            label:
                              "Do you have complete knowledge of the relevant financial markets, products or transactions",
                            size: "col-3",
                          },
                          {
                            // "name": "account_type",
                            label:
                              "To what extent do you rely on financial advice from financial institutions?",
                            size: "col-4",
                          },
                          {
                            // "name": "mode_of_operation",
                            label:
                              "Do you possess any educational qualification?",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            label:
                              "What is your understanding of the risks involved in financial investment generally? Also do you see any specific risks which may relate to a proposed transaction(s) to potentially be carried out with us?",
                            size: "col-12",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            label:
                              "In case of credit or insurance transactions,do you have any relevant experience in relation to similar transactions and what is your understanding of the risks associated with such transactions",
                            size: "col-12",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "commodities_futures_options",
                            label: "Investment",
                            size: "col-4",
                          },
                          {
                            label: "Investment Knowledge",
                            name: "investment_knowledge_commodities_futures_options",
                            size: "col-4",
                          },
                          {
                            name: "investment_experience",
                            label: "Investment experience",
                            size: "col-4",
                          },
                          {
                            name: "commodities_current_investment_amount",
                            label: "Current investment amount (USD)",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "mutual_funds_structured_products",
                            label: "Investment",
                            size: "col-4",
                          },
                          {
                            name: "investment_knowledge_mutual_funds_structured_products",
                            label: "Investment knowledge",
                            size: "col-4",
                          },
                          {
                            name: "investment_experience",
                            label: "Investment experience",
                            size: "col-4",
                          },
                          {
                            name: "current_investment_amount",
                            label: "Current investment amount (USD)",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "exchange_traded_fund",
                            label: "Exchange Traded Funds (Optional)",
                            size: "col-4",
                          },
                          {
                            name: "investment_knowledge_exchange_traded_fund",
                            label: "Investment knowledge",
                            size: "col-4",
                          },
                          {
                            name: "investment_experience",
                            label: "Investment experience(since year)",
                            size: "col-4",
                          },
                          {
                            name: "current_investment_amount",
                            label: "Current investment amount (USD)",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            name: "investment_sub_total",
                            label: "Sub total of investments",
                            size: "col-12",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Net Worth",
                name: "net_worth",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Net Worth",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_2",
                        input_fields: [
                          {
                            name: "net_worth",
                            label: "Net worth (USD)",
                            size: "col-12",
                          },
                          {
                            type: "view_card",
                            title: "",
                            custom_styles: "classname_3",
                            input_fields: [
                              {
                                label: "Net assets",
                                name: "net_assets",
                                size: "col-12",
                              },
                              {
                                type: "document_viewer",
                                name: "employment_supporting_documents",
                                label: "Supporting Documents-1",
                                size: "col-5",
                              },
                              {
                                type: "document_viewer",
                                name: "employment_supporting_documents",
                                label: "Supporting Documents-2",
                                size: "col-5",
                              },
                              {
                                type: "document_viewer",
                                name: "employment_supporting_documents",
                                label: "Supporting Documents-3",
                                size: "col-5",
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Appropriate Annual Income",
                name: "appropriate_annual_income",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Appropriate annual income",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_2",
                        input_fields: [
                          {
                            name: "approx_annual_income",
                            label: "Income from Salary/Business",
                            size: "col-4",
                          },
                          {
                            label: "Return on investments",
                            name: "roi",
                            size: "col-4",
                          },
                          {
                            label: "Rental Income",
                            name: "rental_income",
                            size: "col-4",
                          },
                          {
                            label: "Sale of properties",
                            name: "sale_of_properties",
                            size: "col-4",
                          },
                          {
                            label: "Annuity / Maturity proceeds from insurance",
                            name: "maturing_investments",
                            size: "col-4",
                          },
                          {
                            label: "Others",
                            name: "others",
                            size: "col-4",
                          },
                          {
                            label: "Liabilities",
                            name: "liabilities",
                            size: "col-4",
                          },
                          {
                            label: "Total annual income",
                            name: "total_annual_income",
                            size: "col-4",
                          },
                          {
                            label: "Liabilities & Expenses",
                            name: "liabilities_and_expenses",
                            size: "col-4",
                          },
                          {
                            label: "Net Disposable income",
                            name: "net_disposable_income",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Beneficial owner details",
                name: "beneficial_owner_details",
                show: "true",
                options: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "beneficial_owner_details",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        input_fields: [
                          {
                            label: "Name of the firm",
                            name: "firm_name",
                            size: "col-4",
                          },
                          {
                            label: "Licensed by",
                            name: "licensed_by",
                            size: "col-4",
                          },
                          {
                            label: "Activity",
                            name: "activity",
                            size: "col-4",
                          },
                          {
                            label: "Type of clients",
                            name: "client_type",
                            size: "col-4",
                          },
                          {
                            label: "Holding the position since",
                            name: "position_held_since",
                            size: "col-4",
                          },
                          {
                            label: "Jurisdictions or countries dealth with",
                            name: "jurisdictions_dealth_with",
                            size: "col-4",
                          },
                        ],
                      },
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_2",
                        input_fields: [
                          {
                            // "name" : "professional_client_details_checkbox_2",
                            label:
                              "Do you have complete knowledge of the relevant financial markets, products or transactions",
                            size: "col-4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Risk Profiling",
                name: "risk_profiling",
                show: "true",
                form_elements: [
                  {
                    type: "group",
                    title: "Risk profiling",
                    show: "true",
                    input_fields: [
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_2",
                        input_fields: [
                          {
                            label:
                              "How familiar are you with investments and financial markets?",
                            name: "question_1",
                            size: "col-12",
                          },
                          {
                            label:
                              "Please select a category where you are most likely to invest",
                            name: "question_2",
                            size: "col-12",
                          },
                          {
                            label:
                              "When considering your investments and making investment decisions , do you consider the impact of possible losses or possible gains?",
                            name: "question_3",
                            size: "col-12",
                          },
                          {
                            label:
                              "Assume you had an initial investment portfolio worth $100,000 . If, due to market conditions, your portfolio fell to $85,000 within a month, would you: (If your portfolio has experienced a drop like this, what would your action be ?)",
                            name: "question_4",
                            size: "col-12",
                          },
                          {
                            label:
                              "If the value of your investments then fell to $60,000 over the next 12 months , would you : (If your portfolio has experienced a drop like this , what would your action be?)",
                            name: "question_5",
                            size: "col-12",
                          },
                          {
                            label:
                              "The table below shows the highest one year gain and highest one year loss on five differ ent hypothetical investments of $ 100,000 . Given the potential gain or loss in any one year , where would you invest your money ?",
                            name: "question_6",
                            size: "col-12",
                          },
                          {
                            label:
                              "Where do you see your income level in next 5 years (please do not include your investment income)?",
                            name: "question_7",
                            size: "col-12",
                          },
                          {
                            label:
                              "If you have borrowed before to invest how would you rate your experience?",
                            name: "question_8",
                            size: "col-12",
                          },
                          {
                            label:
                              "For how long would you invest the majority of your money before you think you would need access to it ? (Assuming you already have arrangements in place to meet short term cashflow and / or emergencies.)",
                            name: "question_9",
                            size: "col-12",
                          },
                          {
                            label:
                              "Which of the following statements best describes your risk tolerance",
                            name: "question_10",
                            size: "col-12",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                title: "Additional documents requested",
                name: "additional_documents_requested",
                show: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        type: "document_viewer",
                        name: "income_certificate",
                        label: "Income certificate",
                        size: "col-5",
                      },
                      {
                        type: "document_viewer",
                        name: "rental_agreement",
                        label: "Rental agreement",
                        size: "col-5",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Agreements",
                name: "agreements",
                show: "true",
                form_elements: [
                  {
                    type: "view_card",
                    show: "true",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        type: "agreement",
                        show: "true",
                        input_fields: [
                          {
                            label: "Name",
                            name: "agreement",
                            size: "col-3",
                          },
                          {
                            label: "Status",
                            name: "doc_signed",
                            size: "col-3",
                          },
                          {
                            label: "Signers",
                            name: "signers",
                            size: "col-3",
                          },
                        ],
                      },
                      {
                        type: "agreement",
                        show: "true",
                        input_fields: [
                          {
                            label: "Name",
                            name: "agreement",
                            size: "col-3",
                          },
                          {
                            label: "Status",
                            name: "doc_signed",
                            size: "col-3",
                          },
                          {
                            label: "Signers",
                            name: "signers",
                            size: "col-3",
                          },
                        ],
                      },
                      {
                        type: "agreement",
                        show: "true",
                        input_fields: [
                          {
                            label: "Name",
                            name: "agreement",
                            size: "col-3",
                          },
                          {
                            label: "Status",
                            name: "doc_signed",
                            size: "col-3",
                          },
                          {
                            label: "Signers",
                            name: "signers",
                            size: "col-3",
                          },
                        ],
                      },
                    ],
                  },

                  
                ],
              },
              {
                title: "NCIF status",
                name: "ncif_status",
                show: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "result",
                        label: "Result",
                        size: "col-12",
                      },
                      {
                        type: "document_viewer",
                        name: "result_screenshot_ncif_status",
                        label: "Result screenshot for NCIF",
                        size: "col-4",
                      },
                    ],
                  },
                ],
              },
              {
                title: "Negative media search",
                name: "negative_media_search",
                show: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "result",
                        label: "Result",
                        size: "col-12",
                      },
                      {
                        type: "document_viewer",
                        name: "result_screenshot_nms_status",
                        label: "Result screenshot for negative media search",
                        size: "col-4",
                      },
                    ],
                  },
                ],
              },
              {
                title: "AML risk category",
                name: "aml_risk_category",
                show: "true",
                form_elements: [
                  {
                    type: "view_card",
                    title: "",
                    custom_styles: "classname_2",
                    input_fields: [
                      {
                        name: "category",
                        label: "Category",
                        size: "col-12",
                      },
                      {
                        type: "document_viewer",
                        name: "result_screenshot_nms_status",
                        label: "Result screenshot for negative media search",
                        size: "col-4",
                      },
                      {
                        type: "view_card",
                        title: "",
                        custom_styles: "classname_3",
                        input_fields: [
                          {
                            label: "Remarks",
                            name: "remarks",
                            size: "col-12",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                type: "comment_textarea",
                name: "comment",
                title: "Comment",
                id: "comment",
              },
            ],
          },
        ],
      },
    },
  ],
};
